export const version = 'HEAD';
export const buildDate = '2026-04-14T23:58:48.207Z';
export const commitHash = '810e377';